import { CircularProgress, Typography, styled } from '@mui/material';
import { useMemo } from 'react';

import MobileDashboardItem from './item/MobileDashboardItem';
import { WidgetWithKeyType } from '../../../types/widget';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import { WidgetEnum } from '../../../utils/widgets';

const StyledContainer = styled('div')(({ theme: { spacing } }) => ({
	border: 'none',
	display: 'flex',
	flexDirection: 'column',
	gap: spacing(2),
	paddingTop: spacing(2),
	flex: 1,
}));

const InfoWrapper = styled('div')({
	flex: 1,
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
});

const widgetTypeOrder = [
	WidgetEnum.DOCUMENT_UPLOAD,
	WidgetEnum.HTML,
	WidgetEnum.EXTERNAL_APPLICATIONS,
	WidgetEnum.SIMULATORS,
	WidgetEnum.DOCUMENT_LAST_UPLOADS,
	WidgetEnum.CHART,
	WidgetEnum.CONTACT,
];

type MobileDashboardProps = {
	widgetsWithKey?: WidgetWithKeyType[];
	loading?: boolean;
};

const MobileDashboard = ({ widgetsWithKey = [], loading = false }: MobileDashboardProps) => {
	const sortedWidgetsWithKey = useMemo(() => {
		if (widgetsWithKey.length === 0) return null;

		return widgetsWithKey
			.sort((a, b) => widgetTypeOrder.indexOf(a.widget.type) - widgetTypeOrder.indexOf(b.widget.type))
			.map((widgetWithKey) => (
				<div key={widgetWithKey.key}>
					<MobileDashboardItem widgetWithKey={widgetWithKey} />
				</div>
			));
	}, [widgetsWithKey]);

	return loading ? (
		<InfoWrapper>
			<CircularProgress size={36} color="inherit" />
		</InfoWrapper>
	) : (
		<StyledContainer>
			{widgetsWithKey.length === 0 && (
				<InfoWrapper>
					<Typography variant="h6">Aucun widget</Typography>
				</InfoWrapper>
			)}

			{sortedWidgetsWithKey}
		</StyledContainer>
	);
};

export default MobileDashboard;
